import { render, staticRenderFns } from "./aside-profile.vue?vue&type=template&id=f9bbf5a8&"
import script from "./aside-profile.vue?vue&type=script&lang=js&"
export * from "./aside-profile.vue?vue&type=script&lang=js&"
import style0 from "./aside-profile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports